// extracted by mini-css-extract-plugin
module.exports = {"dragRectangle":"dragRectangle__2PTcy"};